import {
	AppBar,
	Dialog,
	IconButton,
	Toolbar,
	WithStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import MobileStepper from '@material-ui/core/MobileStepper';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
import { Dispatch } from 'redux';

import * as Actions from '../actions/portal';
import PortalNoticeCard from '../components/PortalNoticeCard';
import PortalNoticeGTCard from '../components/PortalNoticeGTCard';
import PortalNoticeGTTableRow from '../components/PortalNoticeGTTableRow';
import PortalNoticeTableRow from '../components/PortalNoticeTableRow';
import ELearningIcon from '../icons/PortalELearning';
import MessageIcon from '../icons/PortalMessages';
import WhatsNewIcon from '../icons/PortalWhatsNew';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import PortalScenarioFactory from '../scenario/PortalScenarioFactory';
import { isValid, MasterItemCode } from '../utils/MasterData';
import { isMobile } from '../utils/MobileCheck';
import { Routes, Screens } from '../utils/Routes';

import CloseIcon from '@material-ui/icons/Close';
import MessageDialog from '../components/MessageDialog';
import CareerDetail from './CareerDetail';
import { TabRow } from './ImstatOnGoing';

import { push } from 'connected-react-router';
import { UpwardTransition } from 'src/utils';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		applyButtons: {
			marginRight: theme.spacing(1),
		},
		careerDialog: {
			width: '80%',
		},
		elTableCell: {
			wordBreak: 'keep-all',
		},
		inlineBoxStyle: {
			overflowWrap: 'break-word',
			wordWrap: 'break-word',
		},
		message: {
			marginBottom: 0,
			padding: theme.spacing(0.5),
		},
		placeholder: {
			marginBottom: 0,
			marginLeft: 'auto',
			marginRight: 'auto',
			marginTop: 0,
			textAlign: 'center',
			width: 250,
			[theme.breakpoints.up('md')]: {
				height: 284,
			},
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(1),
		},
		stepper: {
			backgroundColor: 'transparent',
		},
		swipeableView: {
			[theme.breakpoints.up('md')]: {
				maxHeight: 200,
				minHeight: 200,
			},
		},
		table: {
			height: '100%',
			marginBottom: 0,
			padding: theme.spacing(0.5),
		},
		titleIcon: {
			verticalAlign: 'middle',
		},
		view: {
			margin: theme.spacing(1),
		},
		whatsNew: {
			marginBottom: 0,
			padding: theme.spacing(0.5),
		},

		divScroll: {
			height: 'calc(50vh - 140px)',
			overflowY: 'scroll',
		},
	});

interface IState {
	activeStepMessage: number;
	activeStepWhatsNew: number;
	openErrorJukouStatusSinseiMessageDialog: boolean;
	openErrorStudyOrderMessageDialog: boolean;
	openCareerDetailDialog: boolean;
	careerID: string;
	errorStudyOrderdialogContent: string;
	errorStudyOrderdialogReplaceContent: string[];
}

/**
 * お知らせ画面メイン
 */
class PortalNotice extends React.Component<IProps, IState> {
	protected timerMessage?: number;
	protected timerWhatsNew?: number;

	constructor(props: IProps) {
		super(props);

		this.state = {
			activeStepMessage: 0,
			activeStepWhatsNew: 0,
			careerID: '',
			errorStudyOrderdialogContent: '',
			errorStudyOrderdialogReplaceContent: [],
			openCareerDetailDialog: false,
			openErrorJukouStatusSinseiMessageDialog: false,
			openErrorStudyOrderMessageDialog: false,
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		this.fetchNotices();
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidUpdate(prevProps: IProps) {
		if (prevProps !== this.props) {
			this.resetTimerMessage();
			this.resetTimerWhatsNew();
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		if (this.timerMessage !== undefined) {
			clearTimeout(this.timerMessage);
		}
		if (this.timerWhatsNew !== undefined) {
			clearTimeout(this.timerWhatsNew);
		}
	}

	/**
	 * レンダリング
	 */
	public render() {
		const {
			classes,
			messages,
			whatsNews,
			eLearnings,
			groupTraining,
		} = this.props;

		return (
			<div className={classes.root}>
				<Grid container={true} spacing={2} alignItems="stretch">
					<Grid item={true} xs={12} md={6}>
						<Paper className={classes.message}>
							<Grid
								container={true}
								direction="column"
								alignItems="stretch"
								wrap="nowrap"
							>
								<Grid item={true}>
									<Typography
										variant="h6"
										paragraph={true}
										color="primary"
									>
										<MessageIcon
											className={classes.titleIcon}
										/>
										{i18n.t('PortalNotice_0001')}
									</Typography>
								</Grid>
								{messages.length === 0 ? (
									<Grid item={true} style={{ flexGrow: 1 }}>
										<this.Placeholder
											text={i18n.t('PortalNotice_0002')}
										/>
									</Grid>
								) : (
									<>
										<Grid
											item={true}
											style={{ flexGrow: 1 }}
										>
											<this.Messages
												messages={messages}
											/>
										</Grid>
										<Grid item={true}>
											<Link
												to={Routes.getPath(
													Screens.PERSONAL_MESSAGE_DETAIL
												)}
											>
												<Button color="primary">
													{i18n.t(
														'PortalNotice_0003'
													)}
												</Button>
											</Link>
										</Grid>
									</>
								)}
							</Grid>
						</Paper>
					</Grid>

					<Grid item={true} xs={12} md={6}>
						<Paper className={classes.whatsNew}>
							<Grid
								container={true}
								direction="column"
								alignItems="stretch"
								wrap="nowrap"
							>
								<Grid item={true}>
									<Typography
										variant="h6"
										paragraph={true}
										color="primary"
									>
										<WhatsNewIcon
											className={classes.titleIcon}
										/>
										{i18n.t('PortalNotice_0004')}
									</Typography>
								</Grid>
								{whatsNews.length === 0 ? (
									<Grid item={true} style={{ flexGrow: 1 }}>
										<this.Placeholder
											text={i18n.t('PortalNotice_0005')}
										/>
									</Grid>
								) : (
									<>
										<Grid
											item={true}
											style={{ flexGrow: 1 }}
										>
											<this.WhatsNews
												whatsNews={whatsNews}
											/>
										</Grid>
										<Grid item={true}>
											<Link
												to={Routes.getPath(
													Screens.PERSONAL_WHATS_NEW_DETAIL
												)}
											>
												<Button color="primary">
													{i18n.t(
														'PortalNotice_0006'
													)}
												</Button>
											</Link>
										</Grid>
									</>
								)}
							</Grid>
						</Paper>
					</Grid>
				</Grid>
				<Grid container={true} spacing={2} alignItems="stretch">
					<Grid item={true} xs={12} md={true}>
						<Paper className={classes.table}>
							<Typography
								variant="h6"
								paragraph={true}
								color="primary"
							>
								<ELearningIcon className={classes.titleIcon} />
								{i18n.t('PortalNotice_0007')}
							</Typography>
							<this.ELearnings eLearnings={eLearnings} />
						</Paper>
					</Grid>
					{isValid(MasterItemCode.CAREER_TYPE_CONTROL) && (
						<Grid item={true} xs={12} md={6}>
							<Paper className={classes.table}>
								<Typography
									variant="h6"
									paragraph={true}
									color="primary"
								>
									<ELearningIcon
										className={classes.titleIcon}
									/>
									{i18n.t('PortalNotice_0008')}
								</Typography>
								<this.GroupTraining
									groupTraining={groupTraining}
								/>
							</Paper>
						</Grid>
					)}
				</Grid>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.openCareerDetailDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('PortalNotice_0009')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CareerDetail careerID={this.state.careerID} />
				</Dialog>
			</div>
		);
	}

	/**
	 * 各メッセージ取得
	 */
	protected fetchNotices() {
		this.props.fetchMessages(this.props.token);
		this.props.fetchWhatsNews(this.props.token);
		this.props.fetchELearnings(this.props.token);
		if (isValid(MasterItemCode.CAREER_TYPE_CONTROL)) {
			this.props.fetchGroupTraining(this.props.token);
		}
	}

	/**
	 * 「メッセージ」部
	 */
	protected Messages: React.FC<{
		messages: Actions.IPortalMessage[];
	}> = props => {
		const activeStep = this.state.activeStepMessage;
		const messages = props.messages;
		const maxSteps = messages.length;
		return (
			<div className={this.props.classes.inlineBoxStyle}>
				<Grid container={true} direction="column" alignItems="stretch">
					<Grid item={true} style={{ flexGrow: 1, maxWidth: '100%' }}>
						<SwipeableViews
							index={activeStep}
							onChangeIndex={this.handleStepChangeMessage}
							enableMouseEvents={true}
							className={this.props.classes.swipeableView}
						>
							{messages.map(message => (
								<div
									key={message.messageID}
									className={this.props.classes.view}
								>
									<Typography
										color="inherit"
										variant="subtitle1"
									>
										{message.startDateStr}
									</Typography>
									<Typography color="inherit" variant="h6">
										<span
											dangerouslySetInnerHTML={{
												__html: message.title,
											}}
										/>
									</Typography>
									{message.messageList.map((msg, j) => (
										<React.Fragment key={j}>
											<span
												dangerouslySetInnerHTML={{
													__html: msg,
												}}
											/>
											<br />
										</React.Fragment>
									))}
								</div>
							))}
						</SwipeableViews>
					</Grid>
					<Grid item={true}>
						<MobileStepper
							steps={maxSteps}
							position="static"
							activeStep={activeStep}
							className={this.props.classes.stepper}
							nextButton={
								<Button
									size="small"
									onClick={this.handleNextMessage}
									disabled={activeStep === maxSteps - 1}
								>
									{i18n.t('PortalNotice_0010')}
									<KeyboardArrowRight />
								</Button>
							}
							backButton={
								<Button
									size="small"
									onClick={this.handleBackMessage}
									disabled={activeStep === 0}
								>
									<KeyboardArrowLeft />
									{i18n.t('PortalNotice_0011')}
								</Button>
							}
						/>
					</Grid>
				</Grid>
			</div>
		);
	};

	/**
	 * 「What's New」部
	 */
	protected WhatsNews: React.FC<{
		whatsNews: Actions.IPortalWhatsNew[];
	}> = props => {
		const activeStep = this.state.activeStepWhatsNew;
		const whatsNews = props.whatsNews;
		const maxSteps = whatsNews.length;
		return (
			<div className={this.props.classes.inlineBoxStyle}>
				<Grid container={true} direction="column" alignItems="stretch">
					<Grid item={true} style={{ flexGrow: 1, maxWidth: '100%' }}>
						<SwipeableViews
							index={activeStep}
							onChangeIndex={this.handleStepChangeWhatsNew}
							enableMouseEvents={true}
							className={this.props.classes.swipeableView}
						>
							{whatsNews.map(whatsNew => (
								<div
									key={whatsNew.messageID}
									className={this.props.classes.view}
								>
									<Typography
										color="inherit"
										variant="subtitle1"
									>
										{whatsNew.startDateStr}
									</Typography>
									<Typography color="inherit" variant="h6">
										{whatsNew.titleList.map((title, j) => (
											<React.Fragment key={j}>
												<span
													dangerouslySetInnerHTML={{
														__html: title,
													}}
												/>
												<br />
											</React.Fragment>
										))}
									</Typography>
									{whatsNew.messageList.map((msg, j) => (
										<React.Fragment key={j}>
											<span
												dangerouslySetInnerHTML={{
													__html: msg,
												}}
											/>
											<br />
										</React.Fragment>
									))}
									<div>
										{whatsNew.isBtnApply !== 0 && (
											<BtnApply
												whatsNew={whatsNew}
												className={
													this.props.classes
														.applyButtons
												}
											/>
										)}
										{whatsNew.isBtnResultApply !== 0 && (
											<BtnResultApply
												whatsNew={whatsNew}
											/>
										)}
									</div>
								</div>
							))}
						</SwipeableViews>
					</Grid>
					<Grid item={true}>
						<MobileStepper
							steps={maxSteps}
							position="static"
							activeStep={activeStep}
							className={this.props.classes.stepper}
							nextButton={
								<Button
									size="small"
									onClick={this.handleNextWhatsNew}
									disabled={activeStep === maxSteps - 1}
								>
									{i18n.t('PortalNotice_0012')}
									<KeyboardArrowRight />
								</Button>
							}
							backButton={
								<Button
									size="small"
									onClick={this.handleBackWhatsNew}
									disabled={activeStep === 0}
								>
									<KeyboardArrowLeft />
									{i18n.t('PortalNotice_0013')}
								</Button>
							}
						/>
					</Grid>
				</Grid>
				<MessageDialog
					open={this.state.openErrorJukouStatusSinseiMessageDialog}
					showCancelButton={false}
					title={i18n.t('PortalNotice_0014')}
					contents={[{ content: 'LMCM_E_00677' }]}
					onClose={this.errorMessageJukouStatusSinseiDialogClose}
					onClickOk={this.errorMessageJukouStatusSinseiDialogClose}
				/>
			</div>
		);
	};

	/**
	 * eラーニングコンポーネント
	 */
	protected ELearnings: React.FC<{
		eLearnings: Actions.IPortalELearning[];
	}> = props => {
		if (props.eLearnings.length === 0) {
			return <this.Placeholder text={i18n.t('PortalNotice_0015')} />;
		}
		if (isMobile()) {
			return (
				<>
					<div
						id="elCard"
						style={
							props.eLearnings.length > 5
								? {
										height: '78rem',
										overflowX: 'hidden',
										overflowY: 'auto',
								  }
								: {
										height: '99%',
								  }
						}
					>
						<Grid
							container={true}
							spacing={8}
							direction="row"
							justify="center"
							alignItems="stretch"
						>
							{props.eLearnings.map(eLearning => (
								<Grid
									key={eLearning.careerID + eLearning.classID}
									item={true}
								>
									<PortalNoticeCard
										eLearning={eLearning}
										handleShowDetailDialog={
											this.handleShowDetailDialog
										}
										handleTrainingClick={this.handleTrainingClick(
											eLearning.careerID,
											eLearning.classID,
											eLearning.uncompletedCareers,
											eLearning.unrepresentedCareerCnt
										)}
									/>
								</Grid>
							))}
						</Grid>
					</div>
					<Link
						to={{
							pathname: Routes.getPath(Screens.PERSONAL_STATUS),
							state: {
								tableNumber: TabRow.E_LEARNING,
							},
						}}
					>
						<Button color="primary">
							{i18n.t('PortalNotice_0016')}
						</Button>
					</Link>
					<MessageDialog
						open={this.state.openErrorStudyOrderMessageDialog}
						showCancelButton={false}
						title={i18n.t('PortalNotice_0014')}
						contents={[
							{
								content: this.state
									.errorStudyOrderdialogContent,
								replacements: this.state
									.errorStudyOrderdialogReplaceContent,
							},
						]}
						onClose={this.handleErrorMessageStudyOrderDialogClose}
						onClickOk={this.handleErrorMessageStudyOrderDialogClose}
					/>
				</>
			);
		}

		return (
			<>
				<Table style={{ width: 'calc(100% - 20px)' }}>
					<TableHead>
						<TableRow>
							<TableCell
								className={this.props.classes.elTableCell}
								style={{ width: '15%' }}
							>
								{i18n.t('PortalNotice_0017')}
							</TableCell>
							<TableCell
								className={this.props.classes.elTableCell}
								style={{ width: '35%' }}
							>
								{i18n.t('PortalNotice_0018')}
							</TableCell>
							<TableCell
								className={this.props.classes.elTableCell}
								style={{ width: '10%' }}
							>
								{i18n.t('PortalNotice_0019')}
							</TableCell>
							<TableCell
								className={this.props.classes.elTableCell}
							>
								{i18n.t('PortalNotice_0020')}
							</TableCell>
						</TableRow>
					</TableHead>
				</Table>
				<div className={this.props.classes.divScroll}>
					<Table>
						<TableBody>
							{props.eLearnings.map(eLearning => (
								<PortalNoticeTableRow
									eLearning={eLearning}
									errorMessageJukouStatusSinseiDialogOpen={
										this
											.errorMessageJukouStatusSinseiDialogOpen
									}
									key={eLearning.careerID + eLearning.classID}
									handleShowDetailDialog={
										this.handleShowDetailDialog
									}
									handleTrainingClick={this.handleTrainingClick(
										eLearning.careerID,
										eLearning.classID,
										eLearning.uncompletedCareers,
										eLearning.unrepresentedCareerCnt
									)}
								/>
							))}
						</TableBody>
					</Table>
				</div>
				<Link
					to={{
						pathname: Routes.getPath(Screens.PERSONAL_STATUS),
						state: {
							tableNumber: TabRow.E_LEARNING,
						},
					}}
				>
					<Button color="primary">
						{i18n.t('PortalNotice_0021')}
					</Button>
				</Link>
				<MessageDialog
					open={this.state.openErrorStudyOrderMessageDialog}
					showCancelButton={false}
					title={i18n.t('PortalNotice_0014')}
					contents={[
						{
							content: this.state.errorStudyOrderdialogContent,
							replacements: this.state
								.errorStudyOrderdialogReplaceContent,
						},
					]}
					onClose={this.handleErrorMessageStudyOrderDialogClose}
					onClickOk={this.handleErrorMessageStudyOrderDialogClose}
				/>
			</>
		);
	};

	/**
	 * 集合研修コンポーネント
	 */
	protected GroupTraining: React.FC<{
		groupTraining: Actions.IPortalGroupTraining[];
	}> = props => {
		if (props.groupTraining.length === 0) {
			return <this.Placeholder text={i18n.t('PortalNotice_0022')} />;
		}

		if (isMobile()) {
			return (
				<>
					<div
						id="trCard"
						style={
							props.groupTraining.length > 5
								? {
										height: '75rem',
										overflowX: 'hidden',
										overflowY: 'auto',
								  }
								: {
										height: '99%',
								  }
						}
					>
						<Grid
							container={true}
							spacing={8}
							direction="row"
							justify="center"
							alignItems="stretch"
						>
							{props.groupTraining.map(groupTraining => (
								<Grid
									key={
										groupTraining.title +
										groupTraining.className
									}
									item={true}
								>
									<PortalNoticeGTCard
										groupTraining={groupTraining}
										handleShowDetailDialog={
											this.handleShowDetailDialog
										}
									/>
								</Grid>
							))}
						</Grid>
					</div>
					<Link
						to={{
							pathname: Routes.getPath(Screens.PERSONAL_STATUS),
							state: {
								tableNumber: TabRow.GROUP_TRAINING,
							},
						}}
					>
						<Button color="primary">
							{i18n.t('PortalNotice_0023')}
						</Button>
					</Link>
				</>
			);
		}

		return (
			<>
				<Table style={{ width: 'calc(100% - 20px)' }}>
					<TableHead>
						<TableRow>
							<TableCell style={{ width: '35%' }}>
								{i18n.t('PortalNotice_0024')}
							</TableCell>
							<TableCell style={{ width: '25%' }}>
								{i18n.t('PortalNotice_0025')}
							</TableCell>
							<TableCell>{i18n.t('PortalNotice_0026')}</TableCell>
						</TableRow>
					</TableHead>
				</Table>
				<div className={this.props.classes.divScroll}>
					<Table>
						<TableBody>
							{props.groupTraining.map(groupTraining => (
								<PortalNoticeGTTableRow
									groupTraining={groupTraining}
									key={
										groupTraining.title +
										groupTraining.className
									}
									handleShowDetailDialog={
										this.handleShowDetailDialog
									}
								/>
							))}
						</TableBody>
					</Table>
				</div>
				<Link
					to={{
						pathname: Routes.getPath(Screens.PERSONAL_STATUS),
						state: {
							tableNumber: TabRow.GROUP_TRAINING,
						},
					}}
				>
					<Button color="primary">
						{i18n.t('PortalNotice_0027')}
					</Button>
				</Link>
			</>
		);
	};

	protected handleShowDetailDialog = (
		event: React.MouseEvent<HTMLElement>
	) => {
		const dataCareerID = event.currentTarget.getAttribute('data-careerid');
		if (dataCareerID) {
			this.setState({
				careerID: dataCareerID,
				openCareerDetailDialog: true,
			});
		}
	};

	/**
	 * 受講ボタン処理
	 * @param e イベントオブジェクト
	 */
	protected handleTrainingClick = (
		careerID: string,
		classID: string,
		uncompletedCareers: string,
		unrepresentedCareerCnt: string
	) => (e: React.MouseEvent<HTMLElement>) => {
		if (uncompletedCareers !== null && uncompletedCareers !== '') {
			this.handleErrorMessageStudyOrderDialogOpen();
			if (unrepresentedCareerCnt !== '0') {
				this.setState({ errorStudyOrderdialogContent: 'LMCM_E_15513' });
				this.setState({
					errorStudyOrderdialogReplaceContent: [
						uncompletedCareers,
						unrepresentedCareerCnt,
					],
				});
			} else {
				this.setState({ errorStudyOrderdialogContent: 'LMCM_E_15512' });
				this.setState({
					errorStudyOrderdialogReplaceContent: [uncompletedCareers],
				});
			}
		} else {
			let pathname = Routes.getPath(Screens.ELEARNING);
			pathname = pathname.replace(/\/:career_id\//, `/${careerID}/`);
			pathname = pathname.replace(/\/:class_id$/, `/${classID}`);
			this.props.pushHistoryState(pathname, {
				caller: window.location.pathname,
			});
		}
	};

	/**
	 * 受講ボタンエラーメッセージクローズ
	 */
	protected handleErrorMessageStudyOrderDialogClose = () => {
		this.setState({ openErrorStudyOrderMessageDialog: false });
	};

	/**
	 * 受講ボタンエラーメッセージオープン
	 */
	protected handleErrorMessageStudyOrderDialogOpen = () => {
		this.setState({ openErrorStudyOrderMessageDialog: true });
	};

	protected handlecloseDetailDialog = () => {
		this.setState({ careerID: '', openCareerDetailDialog: false });
	};

	/**
	 * 受講申請中受講ボタンエラーメッセージクローズ
	 */
	protected errorMessageJukouStatusSinseiDialogClose = () => {
		this.setState({ openErrorJukouStatusSinseiMessageDialog: false });
	};

	/**
	 * 受講申請中受講ボタンエラーメッセージオープン
	 */
	protected errorMessageJukouStatusSinseiDialogOpen = () => {
		this.setState({ openErrorJukouStatusSinseiMessageDialog: true });
	};

	/*
	 * メッセージ次へボタンハンドラ
	 */
	protected handleNextMessage = () => {
		this.setState(prevState => ({
			activeStepMessage: prevState.activeStepMessage + 1,
		}));
		this.resetTimerMessage();
	};

	/**
	 * メッセージ前へボタンハンドラ
	 */
	protected handleBackMessage = () => {
		this.setState(prevState => ({
			activeStepMessage: prevState.activeStepMessage - 1,
		}));
		this.resetTimerMessage();
	};

	/**
	 * メッセージステッパーハンドラ
	 */
	protected handleStepChangeMessage = (activeStepMessage: number) => {
		this.setState({ activeStepMessage });
		this.resetTimerMessage();
	};

	/**
	 * What's New次へボタンハンドラ
	 */
	protected handleNextWhatsNew = () => {
		this.setState(prevState => ({
			activeStepWhatsNew: prevState.activeStepWhatsNew + 1,
		}));
		this.resetTimerWhatsNew();
	};

	/**
	 * What's New前へボタンハンドラ
	 */
	protected handleBackWhatsNew = () => {
		this.setState(prevState => ({
			activeStepWhatsNew: prevState.activeStepWhatsNew - 1,
		}));
		this.resetTimerWhatsNew();
	};

	/**
	 * What's Newステッパーハンドラ
	 */
	protected handleStepChangeWhatsNew = (activeStepWhatsNew: number) => {
		this.setState({ activeStepWhatsNew });
		this.resetTimerWhatsNew();
	};

	/**
	 * メッセージ表示タイマ設定
	 */
	protected resetTimerMessage() {
		const interval = this.props.interval;
		if (!interval) {
			return;
		}

		if (this.props.messages.length === 0) {
			return;
		}

		if (this.timerMessage !== undefined) {
			clearTimeout(this.timerMessage);
		}

		// 一定時間ごとにメッセージを切り替える
		const timer = () => {
			const { activeStepMessage } = this.state;
			this.timerMessage = window.setTimeout(timer, interval);
			if (activeStepMessage === this.props.messages.length - 1) {
				this.setState({ activeStepMessage: 0 });
			} else {
				this.setState({
					activeStepMessage: this.state.activeStepMessage + 1,
				});
			}
		};
		this.timerMessage = window.setTimeout(timer, interval);
	}

	/**
	 * What's New表示タイマ設定
	 */
	protected resetTimerWhatsNew() {
		if (!this.props.interval) {
			return;
		}
		const interval = this.props.interval + 1000;

		if (this.props.whatsNews.length === 0) {
			return;
		}

		if (this.timerWhatsNew !== undefined) {
			clearTimeout(this.timerWhatsNew);
		}

		// 一定時間ごとにメッセージを切り替える
		const timer = () => {
			const { activeStepWhatsNew } = this.state;
			this.timerWhatsNew = window.setTimeout(timer, interval);
			if (activeStepWhatsNew === this.props.whatsNews.length - 1) {
				this.setState({ activeStepWhatsNew: 0 });
			} else {
				this.setState({
					activeStepWhatsNew: this.state.activeStepWhatsNew + 1,
				});
			}
		};
		this.timerWhatsNew = window.setTimeout(timer, interval);
	}

	/**
	 * プレースホルダコンポーネント
	 */
	protected Placeholder: React.FC<{ text: string }> = props => {
		return (
			<div className={this.props.classes.placeholder}>
				<Typography variant="caption">{props.text}</Typography>
			</div>
		);
	};
}

const BtnApply: React.FC<{
	className: any;
	whatsNew: Actions.IPortalWhatsNew;
}> = props => {
	if (props.whatsNew.isBtnApply === 2) {
		return (
			<Button
				variant="contained"
				disabled={true}
				className={props.className}
				size="small"
			>
				{props.whatsNew.careerTypeID === 10
					? i18n.t('PortalNotice_0028')
					: i18n.t('PortalNotice_0029')}
			</Button>
		);
	}

	return (
		<Link
			to={{
				pathname: Routes.getPath(Screens.PERSONAL_LECTURE_APPLICATION),
				state: {
					caller: window.location.pathname,
					careerType: props.whatsNew.careerTypeID === 10 ? '10' : '0',
					targetCareerId: props.whatsNew.careerID,
				},
			}}
		>
			<Button variant="outlined" className={props.className} size="small">
				{props.whatsNew.careerTypeID === 10
					? i18n.t('PortalNotice_0030')
					: i18n.t('PortalNotice_0031')}
			</Button>
		</Link>
	);
};

const BtnResultApply: React.FC<{
	whatsNew: Actions.IPortalWhatsNew;
}> = props => {
	if (props.whatsNew.isBtnResultApply === 2) {
		return (
			<Button variant="contained" disabled={true} size="small">
				{i18n.t('PortalNotice_0032')}
			</Button>
		);
	}
	if (props.whatsNew.classID && props.whatsNew.classID !== '') {
		let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_APPLICATION);
		to = to.replace(/\/:career_id/, `/${props.whatsNew.careerID}`);
		to = to.replace(/\/:class_id/, `/${props.whatsNew.classID}`);
		to = to.replace(/\/:nittei_only_flg/, `/0`);
		return (
			<Link
				to={{
					pathname: to,
					state: {
						caller: window.location.pathname,
						skillViewFlg: props.whatsNew.careerTypeID === 10,
					},
				}}
			>
				<Button variant="outlined" size="small">
					{i18n.t('PortalNotice_0033')}
				</Button>
			</Link>
		);
	} else {
		return (
			<Link
				to={{
					pathname: Routes.getPath(
						Screens.PERSONAL_LECTURE_APPLICATION
					),
					state: {
						caller: window.location.pathname,
						careerType:
							props.whatsNew.careerTypeID === 10 ? '10' : '0',
						resultApply: true,
						targetCareerId: props.whatsNew.careerID,
					},
				}}
			>
				<Button variant="outlined" size="small">
					{i18n.t('PortalNotice_0034')}
				</Button>
			</Link>
		);
	}
};

const mapStateToProps = (state: IRootState) => ({
	distanceLearning: state.portal.distanceLearning,
	eLearnings: state.portal.eLearnings,
	groupTraining: state.portal.groupTraining,
	messages: state.portal.messages,
	whatsNews: state.portal.whatsNews,

	token: state.session.token,

	interval: state.login.carouselChangeInterval,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchELearnings: (token: string) => {
		const scenario = PortalScenarioFactory.fetchELearnings(dispatch, token);
		scenario.run({});
	},
	fetchGroupTraining: (token: string) => {
		const scenario = PortalScenarioFactory.fetchGroupTraining(
			dispatch,
			token
		);
		scenario.run({});
	},
	fetchMessages: (token: string) => {
		const scenario = PortalScenarioFactory.createFetchMessages(
			dispatch,
			token
		);
		scenario.run({});
	},
	fetchWhatsNews: (token: string) => {
		const scenario = PortalScenarioFactory.fetchWhatsNews(dispatch, token);
		scenario.run({});
	},
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
});

// tslint:disable-next-line: no-empty-interface
export interface IPortalNoticeProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IPortalNoticeProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(PortalNotice);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/PortalNotice.tsx